import { render, staticRenderFns } from "./ProductComponent.vue?vue&type=template&id=7a7838c7&scoped=true"
import script from "./ProductComponent.vue?vue&type=script&lang=js"
export * from "./ProductComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductComponent.vue?vue&type=style&index=0&id=7a7838c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7838c7",
  null
  
)

export default component.exports